import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import moment from "moment";

import followUpComponent from "../../components/followUp/followUpComponent";

class VisitManager extends Controller {
	constructor() {
		super("visitManager");
		this.remoteClassName = "client-visit";
	}

	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						let visitList = Shark.getInstanceList("Visit", data.items);

						if (incrementalRequest) {
							visitList = [...Shark.get("visitList"), ...visitList];
						}

						Shark.set({
							visitList,
							__visitListNeedFurtherLoad: data.availableItemCount > visitList.length,
							__availableFurtherItems: data.availableItemCount - visitList.length,
						});

						return {
							data: visitList,
							requestedAction,
							status: "ok"
						}
					case 404:
						return {
							data: null,
							requestedAction,
							status: "ko"
						}
				}
			}
		});
	}

	getList (dateFrom, dateTo, range, incrementalRequest = false) {
		const rd = NousCore.api.createRequest();

		if (range) {
			rd.range = range;
		}

		if (dateFrom || dateTo) {
			rd.filters = {
				dateFrom,
				dateTo,
			};
		}

		return NousCore.api.send("client-visit/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						// Shark.set("visitAvailableItemCount", data.availableItemCount);
						let visitList = Shark.getInstanceList("Visit", data.items);

						if (incrementalRequest) {
							visitList = [...Shark.get("visitList"), ...visitList];
						}

						// visitList.sort((a, b) => {
						// 	if (a.updatedAt < b.updatedAt) {
						// 		return 1;
						// 	}
						// 	else if (a.updatedAt > b.updatedAt) {
						// 		return -1;
						// 	}
						// });

						// const visitRecap = {
						// 	1: 0,
						// 	future_v: 0,
						// 	future_p: 0,
						// 	5: 0,
						// 	6: 0,
						// };
						
						// const oneMonthAgo = moment().add(-1, "M");

						// visitList.forEach(item => {
						// 	if (item.referenceDate >= oneMonthAgo && visitRecap.hasOwnProperty(item.outcome)) {
						// 		visitRecap[item.outcome]++;
						// 	}
						// });

						// const latestVisitList = visitList.slice(0, 5);

						console.log({visitList});
						Shark.set({
							// latestVisitList,
							visitAvailableItemCount: data.availableItemCount,
							visitList,
							__visitListNeedFurtherLoad: data.availableItemCount > visitList.length,
							__availableFurtherItems: data.availableItemCount - visitList.length,
							// visitRecap,
						});

						visitManager.emit("listChanged");
						return {}
						break;
					case 404:
						visitManager.emit("listGetError");
						return {}
						break;
				}
			}
		});
	}

	updateActivityStatus (guid) {
		const rd = NousCore.api.createRequest({item: {guid} });
		const requestedAction = "update-activity-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				return {
					data,
					requestedAction,
					status: "ko"
				};
			}
		});
	}





	
	delete () {
		const rd = NousCore.api.createRequest({ item: { guid: Shark.get("currVisit").guid }});

		NousCore.api.send("client-visit/delete", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						visitManager.emit("visitDeleted");
						break;
					case 404:
						visitManager.emit("visitDeletionError");
						break;
				}
			}
		});
	}


	getByClientGuid (guid) {
		const rd = NousCore.api.createRequest({ item: { guid: guid } });

		return NousCore.api.send("client-visit/get-by-client-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const visits = Shark.getInstanceList("Visit", data.items);

						if (visits.length > 0) {
							const visitList = Shark.get("visitList");
							if (visitList) {
								const visitIndex = Utils.safp(visitList, "guid", visits[0].guid, "index");
								
								if (visitIndex > -1) {
									visitList[visitIndex] = visits[0];
								}
							}
						}

						return {
							data: visits,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({ item: { guid: guid } });

		return NousCore.api.send("client-visit/get-by-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const visits = Shark.getInstanceList("Visit", data.items);

						return {
							data: visits,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getByProspect (prospect) {
		const rd = NousCore.api.createRequest({ item: { guid: prospect.guid } });

		return NousCore.api.send("client-visit/get-by-prospect", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const currVisit = Shark.getInstanceList("Visit", data.items)[0];
						followUpComponent.set("targetItem", currVisit);
						
						Shark.set({
							currVisit,
							__isEditingVisit: false
						});
						// Shark.openPage(visitEditView);
						return {
							data: currVisit,
							requestedAction: "get-by-prospect",
							status: "ok",
						};
					case 404:
						return {
							data: null,
							requestedAction: "get-by-prospect",
							status: "ko",
						};
				}
			}
		});
	}

	getBySiteInfoSheetGuid (guid) {
		const rd = NousCore.api.createRequest({ item: { guid: guid } });

		return NousCore.api.send("client-visit/get-by-site-info-sheet-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const visits = Shark.getInstanceList("Visit", data.items);

						return {
							data: visits,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}


	// getListByAgentAndClient (agent_guid, client_guid) {
	// 	const rd = NousCore.api.createRequest({ item: { agentGuid: agent_guid, clientGuid: client_guid } });

	// 	NousCore.api.send("client-visit/get-list-by-agent-and-client", rd, function (data) {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					Shark.set("visitList", Shark.getInstanceList("Visit", data.items));
	// //Shark.render();
	// 					visitManager.emit("listChanged");
	// 					break;
	// 				case 404:
	// 					visitManager.emit("listGetError");
	// 					break;
	// 			}
	// 		}
	// 	});
	// }

	getListByGuid (id) {
		const rd = NousCore.api.createRequest({ item: { guid: id } });

		NousCore.api.send("client-visit/get-list-by-agent", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("visitList", Shark.getInstanceList("Visit", data.items));

						visitManager.emit("listChanged");
						break;
					case 404:
						visitManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (visit) {
		const rd = NousCore.api.createRequest({ item: visit.export() });
		const action = visit.guid === "" ? "insert" : "update";

		return NousCore.api.send(`client-visit/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						visit.import(data.items[0]);
						visit.clean();
						visitManager.emit("visitSaved");
						return {
							data: visit,
							requestedAction: action,
							status: "ok"
						};
					case 99:
						visitManager.emit("visitSaveError");
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

}

const visitManager = new VisitManager();

Shark.registerController(visitManager);

export { visitManager };
